export default "__VITE_ASSET__Gi8rYLAR__"